/**
 * Open Bet Results API Adater
 *
 * @module app/components/ResultsApiAdapter
 */
import jQuery from 'jquery';
import Translator from './Translator';

/**
 * API has been initialised
 *
 * @type {boolean}
 *
 * @private
 */
var initialised = false;

/**
 * API has been initialised with an error
 *
 * @type {boolean}
 *
 * @private
 */
var resultsApiError = false;

/**
 * Open Bet Results API Object
 *
 * @type {Object}
 *
 * @private
 */
var resultsAPIObject = null;

/**
 * Retrieve the Open Bet API Version and Initialize in case API is there
 *
 * @param {function}
 *
 * @returns {string}
 *
 * @private
 */
var getVersion = function getVersion(callback) {

    /**
     * On success callback
     *
     * @param {Object} data JSON object containing the API Version
     *
     * @returns {string}
     *
     * @private
     */
    var onSuccess = function onSuccess(data) {

        callback(data);
    };

    /**
     * On error callback
     *
     * @param {Object} error error object
     *
     * @returns {string}
     *
     * @private
     */
    var onError = function onError() {

        resultsApiError = true;

        return 'versionError';
    };

    jQuery.ajax({
        async: true,
        cache: false,
        url: window.WH.sportsbook.resultsAPIVersionUrl,
        success: onSuccess,
        error: onError,
        dataType: 'json',
    });

};

var getResultsFormatLocale = function () {

    return window.WH.sportsbook.resultsAPILocales[Translator.getLocale()] || 'en';
};

/**
 * Initialize Open Bet Results API
 *
 * @returns {void}
 *
 * @private
 */
var initResultAPI = function initResultAPI(onSuccess) {


    /**
     * Callback to initialise the resultsAPI after getting the API version
     *
     * @returns {void}
     *
     * @private
     */
    var callback = function callback(data) {

        if (window.ResultsAPI) {

            resultsAPIObject = window.ResultsAPI();

            resultsAPIObject.init({
                'rs_url': window.WH.sportsbook.resultsAPIConfigUrl + '/' + data.version,
                'lang': getResultsFormatLocale(),
                'device': 'DEFAULT',
            }, jQuery);

            initialised = true;
            onSuccess();
        } else {

            initialised = false;
        }
    };

    getVersion(callback);
};

/**
 * Public API.
 *
 * @type {Object}
 *
 * @private
 */
var api = {

    /**
     * Perform initialisation.
     *
     * @returns {void}
     *
     * @public
     */
    init: function init(callback) {

        if (!initialised && !resultsApiError) {

            initResultAPI(callback);
        } else {

            callback();
        }
    },

    /**
     * Get RaceCard Result by race event ID
     *
     * @param {String} raceEvent event ID string
     * @param {Function} successCallback success callback
     * @param {Function} errorCallback error callback
     *
     * @returns {void}
     *
     * @public
     */
    getRaceCardByMeetingEventId: function getRaceCardByMeetingEventId(raceEvent, successCallback, errorCallback) {

        var raceEventId = parseInt(raceEvent.substr(5));

        /**
         * Initialize callback after ResultsAPI version is retrieved
         *
         * @returns {void}
         *
         * @private
         */
        var callback = function () {

            if (!resultsApiError && initialised) {

                resultsAPIObject.getRaceCardByMeetingEventId(raceEventId, successCallback, errorCallback);
            } else {

                errorCallback('Results API not initialised');
            }
        };

        api.init(callback);
    },

    /**
     * Get Markets by race event
     *
     * @param {String} raceEvent event ID string
     * @param {Function} successCallBack success callback
     * @param {Function} errorCallback error callback
     *
     * @returns {void}
     *
     * @public
     */
    getMarketsByMeetingEventId: function getMarketsByMeetingEventId(raceEvent, successCallback, errorCallback) {

        var raceEventId = parseInt(raceEvent.substr(5));

        /**
         * Initialize callback after ResultsAPI version is retrieved
         *
         * @returns {void}
         *
         * @private
         */
        var callback = function () {

            if (!resultsApiError && initialised) {

                resultsAPIObject.getMarketsByMeetingEventId(
                    raceEventId, true, successCallback, errorCallback
                );

            } else {

                errorCallback('Results API not initialised');
            }
        };

        api.init(callback);
    },
};

export default api;
